import { Injectable } from '@angular/core';

// https://github.com/heysimonarnold/Detect-Keyboard-User/blob/master/detect-keyboard-user.js
@Injectable({
  providedIn: 'root'
})
export class UserInputModeDetectorService {

  keyboardHandler = this.dkuHandleKeyboard.bind(this);
  pointerHandler = this.dkuHandlePointer.bind(this);
  constructor() {
    document.documentElement.classList.add('pointer-user');
    window.addEventListener('keydown', this.keyboardHandler, true);
  }

  dkuHandlePointer() {
    document.documentElement.classList.add('pointer-user');
    document.documentElement.classList.remove('keyboard-user');
    window.removeEventListener('mousedown', this.pointerHandler, true);
    window.removeEventListener('touchstart', this.pointerHandler, true);
    window.addEventListener('keydown', this.keyboardHandler, true);
  }

  dkuHandleKeyboard(e: KeyboardEvent) {
    if (e.keyCode === 9) { // the "I am a keyboard user" key
      document.documentElement.classList.add('keyboard-user');
      document.documentElement.classList.remove('pointer-user');
      window.removeEventListener('keydown', this.keyboardHandler, true);
      window.addEventListener('mousedown', this.pointerHandler, true);
      window.addEventListener('touchstart', this.pointerHandler, true);
    }
  }
}
